import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerCategories = categories.slice(0, 6);

  return (
    <footer className="w-full bg-primary-900">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-[family-name:var(--font-label)]">
              OOPBuy Spreadsheet
            </h4>
            <p className="text-xs text-foreground-300 leading-relaxed font-[family-name:var(--font-body)]">
              Das umfassendste OOPBuy Spreadsheet für den deutschen Markt. Entdecke Sneaker, Kleidung und Accessoires mit unseren optimierten Guides.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4 font-[family-name:var(--font-label)]">
              SEO Ratgeber
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-ratgeber" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]">
                  OOPBuy Spreadsheet Ratgeber
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-vergleich" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]">
                  OOPBuy vs Alternativen
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-sicherheit" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]">
                  Sicherheitsguide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-versand" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]">
                  Versandguide Deutschland
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-einkaufsfuehrer" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]">
                  Einkaufsführer Für Anfänger
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4 font-[family-name:var(--font-label)]">
              Kategorien
            </h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-foreground-400 mb-4 font-[family-name:var(--font-label)]">
              Hauptwebsite
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]"
                >
                  oopbuy spreadsheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400 font-[family-name:var(--font-body)]">
              &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/"
                className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]"
              >
                Datenschutz
              </Link>
              <Link
                to="/"
                className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer font-[family-name:var(--font-body)]"
              >
                Impressum
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-primary-950/50 py-8">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
          <p className="text-5xl md:text-8xl font-heading font-black text-primary-800/30 tracking-tight text-center select-none">
            OOPBUY
          </p>
        </div>
      </div>
    </footer>
  );
}